import * as convert from '_core/utils/convert';

const toCurrencyId = (value) => {
  if (value == null) {
    return undefined;
  }

  if (typeof value === 'object') {
    value = value.id ?? value.currency?.id ?? undefined;
  }

  const id = convert.toInt(value);

  return id > 0 ? id : undefined;
};

export const getWarehouseCurrencyId = (warehouse) => toCurrencyId(warehouse?.currency);

export const getReplaceCurrencyId = ({
  scope,
  replaceCurrency,
  fallback,
  warehouse,
  fromWarehouse,
}) => {
  if (fromWarehouse) {
    const warehouseCurrencyId = getWarehouseCurrencyId(warehouse);

    if (warehouseCurrencyId) {
      return warehouseCurrencyId;
    }
  }

  const replaceCurrencyId = toCurrencyId(replaceCurrency?.[scope]);

  if (replaceCurrencyId) {
    return replaceCurrencyId;
  }

  return toCurrencyId(fallback);
};
